export const toDecimals = (value: number, decimalCount: number): number => {
  return parseFloat(value.toFixed(decimalCount))
}

export const removeSeperatorsFromNumberString = (value: string) => {
  return Number(value.replaceAll(".", "").replaceAll(",", ""))
}

export const numberFormatter = new Intl.NumberFormat("da-DK")
